// In src/Page.js

import React from 'react';
import PrismicReact from 'prismic-reactjs';
import Prismic from 'prismic-javascript';
import PrismicConfig from '../../prismic-configuration';

import HexaContainer from '../../Components/HexaContainer/HexaContainer';
import Slider from '../../Components/Slider/Slider';
import NotFound from '../../NotFound';

import styles from './Project.scss';

// Declare your component
export default class Project extends React.Component {
  
  state = {
    doc: null,
    notFound: false,
    relatedProjects: null,
  }

  componentWillMount() {
    this.fetchPage(this.props);
  }
  
  componentWillReceiveProps(props) {
    this.fetchPage(props);
  }
  
  componentDidUpdate() {
    this.props.prismicCtx.toolbar();
  }
  
  fetchPage(props) {
    if (props.prismicCtx) {
      // We are using the function to get a document by its uid
      return props.prismicCtx.api.getByUID('project', props.match.params.uid, {}, (err, doc) => {
        if (doc) {
          // We put the retrieved content in the state as a doc variable
          this.setState({ doc });
          this.getRelatedProjects()
        } else {
          // We changed the state to display error not found if no matched doc
          this.setState({ notFound: !doc });
        }
      });
    }
    return null;
  }

  getRelatedProjects(){
    const apiEndpoint = 'https://tibor.prismic.io/api/v2';
    
    Prismic.api(apiEndpoint).then(api => {
      api.query(
        Prismic.Predicates.any('document.tags', this.state.doc.tags)
      ).then(response => {
        // response is the response object, response.results holds the documents
        this.setState({relatedProjects: response.results})
      });
    })
  }

  showRelatedProjects(project){
    return(
      <React.Fragment>
        <h5>Soortgelijke projecten:</h5>
        <ul>
          {// eslint-disable-next-line 
            project.map((item, index) => {
            if(item.uid !== this.state.doc.uid){
              return(
                <li key={'related_project_'+index}>
                    {/* <a href={Link.url(subItems.sub_nav_link, PrismicConfig.linkResolver)} key={'sub_item'+index} className={styles.menu_item}>{subItems.sub_nav_link_lable[0].text}</a> */}
                  <a href={PrismicConfig.linkResolver(item)}>
                    {PrismicReact.RichText.asText(item.data.name)}
                  </a>
                </li>
              )
            }
          })}
        </ul>
      </React.Fragment>
    )
  }

  render() {
    if (this.state.doc) {
        const slides = this.state.doc.data.slider;

        return (
          <React.Fragment>
            <HexaContainer key={'project_header_' + this.state.doc.data.name} elements={[
              <div className={styles.project} key={'project_' + this.state.doc.data.name}>
                  <Slider slides={slides} />
                  <h1>{PrismicReact.RichText.asText(this.state.doc.data.name)}</h1>
                  {PrismicReact.RichText.render(this.state.doc.data.description, this.props.prismicCtx.linkResolver)}
                  <div className={styles.project_meta}>
                    <div className={styles.project_meta_date}>{this.state.doc.data.date}</div>
                    {this.state.doc.tags.map(tag => {
                      return <span key={tag} className={styles.project_meta_tag}>{tag}</span>;
                    })}
                  </div>
              </div>
              ]} type={'project_detail'} backgroundImageUrl={this.state.doc.data.featured_image.url} extraClass={styles.header_hexa} />
              <div className={styles.project_information}>
                {PrismicReact.RichText.render(this.state.doc.data.about, this.props.prismicCtx.linkResolver)}
                {this.state.relatedProjects && this.showRelatedProjects(this.state.relatedProjects)}
              </div>
            <HexaContainer key={'project_footer_' + this.state.doc.data.name} type={'empty'} extraClass={styles.footer_hexa} />
          </React.Fragment>
        );
    } else if (this.state.notFound) {
      return <NotFound />;
    }
    return <h1>Loading</h1>;
  }
}


// WEBPACK FOOTER //
// ./src/Pages/Project/Project.js